import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import {
  STEP_HEADER_CARD_SX,
  STEP_HEADER_CONTENT_SX,
  STEP_HEADER_TITLE_SX,
  STEP_HEADER_SUBTITLE_SX,
} from "./stepComponentStyles";

function StepHeaderCard({ title, subtitle }) {
  return (
    <Grid item xs={12}>
      <Card variant="outlined" sx={STEP_HEADER_CARD_SX}>
        <CardContent sx={STEP_HEADER_CONTENT_SX}>
          <Typography variant="h5" sx={STEP_HEADER_TITLE_SX}>
            {title}
          </Typography>

          {subtitle ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={STEP_HEADER_SUBTITLE_SX}
            >
              {subtitle}
            </Typography>
          ) : null}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default StepHeaderCard;